import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";
import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const baseURL =
  import.meta.env.VITE_HISTORICAL_INVOICES_BACKEND_API_URL ||
  "http://localhost:4002/api";

const historicoApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

setupAuthInterceptor(historicoApi);

historicoApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  },
);

export { historicoApi };
